//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['company', 'allowRemind'],
    data: function data() {
        var _this = this;

        var data = {
            url: route('sanctum_api.users.index'),
            companyData: this.company > 0 ? { companies: [this.company] } : null,
            columns: [{
                name: 'username',
                label: trans('columns.username'),
                sortable: true
            }, {
                name: 'firstname',
                label: trans('columns.firstname'),
                sortable: true
            }, {
                name: 'lastname',
                label: trans('columns.lastname'),
                sortable: true
            }, {
                name: 'usertype',
                label: trans('columns.usertype'),
                sortable: true,
                data: function data(item, column) {
                    return trans('roles.' + item.usertype);
                }
            }, {
                name: 'manager',
                label: trans('columns.manager_name'),
                sortable: false,
                data: function data(item, column) {
                    return item.manager ? item.manager.name : '–';
                }
            }, {
                name: 'globalstate',
                label: trans('columns.globalstate'),
                sortable: true,
                html: true,
                data: function data(item, column) {
                    return _this.makeUserStateHtml(item.globalstate);
                }
            }]
        };

        if (!(this.company > 0)) {
            data.columns.unshift({
                name: 'company',
                label: trans('columns.companyname'),
                sortable: true,
                data: function data(item, column) {
                    return item.company ? item.company.name : '–';
                }
            });
        }

        return data;
    },

    methods: {
        makeUserStateHtml: function makeUserStateHtml(globalstate) {
            var badgeClass = '';
            var badgeText = '';
            var outsideText = '';

            if (globalstate === 'red (none)') {
                badgeClass = 'badge-secondary';
                badgeText = trans('messages.no_trainings_assigned');
            } else if (globalstate.startsWith('red')) {
                badgeClass = 'badge-danger';
                badgeText = trans('messages.invalid');
                if (globalstate.lastIndexOf('(') !== -1) {
                    outsideText = '&nbsp;' + globalstate.substring(globalstate.lastIndexOf('(') - 1);
                }
            } else if (globalstate.startsWith('yellow')) {
                badgeClass = 'badge-warning';
                badgeText = trans('messages.expiring');
            } else if (globalstate.startsWith('green')) {
                badgeClass = 'badge-success';
                badgeText = trans('messages.valid');
            } else {
                badgeClass = 'badge-danger';
                badgeText = '(unknown)';
            }

            return '<span class="badge ' + badgeClass + '"> ' + badgeText + '</span>' + outsideText;
        },
        isImpersonateDisabled: function isImpersonateDisabled(user) {
            return window.Laravel.isImpersonating;
        },
        canImpersonateUser: function canImpersonateUser(user) {
            if (!window.Laravel.permissions.includes('users.impersonate')) {
                return false;
            }
            if (user.id === window.Laravel.user.id) {
                return false;
            }
            if (user.level > window.Laravel.user.level) {
                return false;
            }

            if (window.Laravel.user.usertype === 'manager') {
                return window.Laravel.managerCanImpersonateManager || user.usertype === 'user';
            }

            return true;
        },
        canDelete: function canDelete(user) {
            if (!window.Laravel.permissions.includes('users.delete')) {
                return false;
            }
            if (window.Laravel.user.usertype === 'manager') {
                if (user.usertype !== 'user') {
                    return false;
                }
                if (user.manager && user.manager.id !== window.Laravel.user.id) {
                    return false;
                }
            }

            return true;
        },
        canEdit: function canEdit(user) {
            if (!window.Laravel.permissions.includes('users.edit')) {
                return false;
            }
            /*if (window.Laravel.user.usertype === 'manager') {
                if (user.usertype_raw !== 'user' && user.id !== window.Laravel.user.id) {
                    return false;
                }
            }*/

            return true;
        },
        sendReminderMail: function sendReminderMail(userid) {
            swal({
                title: 'Erinnerungs Mail versenden?',
                text: 'Möchten sie wirklich die Erinnerungsmail versenden?',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.get(route('users.remind', userid)).then(function (response) {
                        swal({
                            title: window.i18n.messages.success,
                            html: window.i18n.messages.mail_success,
                            type: 'success',
                            timer: 1000,
                            showConfirmButton: false
                        }).then(function () {
                            //location.reload();
                        });
                    }).catch(function (error) {
                        if (error.response) {
                            swal({
                                title: window.i18n.messages.error,
                                text: error.response.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            });
        },
        oneTimePassword: function oneTimePassword(userId) {
            swal({
                title: 'Neues Password',
                text: 'Möchten sie wirklich ein neues Passwort setzten ?.',
                type: 'question',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: window.i18n.messages.proceed,
                cancelButtonText: window.i18n.messages.cancel
            }).then(function (result) {
                if (result.value) {
                    axios.get(route('users.new_password', userId)).then(function (response) {
                        swal({
                            title: 'Neues Passwort',
                            html: 'Benutzername: ' + response.data.username + '<br>Neues Passwort: ' + response.data.password,
                            type: 'success',
                            showConfirmButton: true
                        }).then(function () {
                            //location.reload();
                        });
                    }).catch(function (error) {
                        if (error.response) {
                            swal({
                                title: window.i18n.messages.error,
                                text: error.response.data.message,
                                type: 'error'
                            });
                        }
                    });
                }
            });
        },
        impersonate: function impersonate(userId) {
            axios.post(route('users.impersonate', userId)).then(function () {
                location.href = "/";
            }).catch(function (error) {
                if (error.response) {
                    swal({
                        title: window.i18n.messages.error,
                        text: error.response.data.message,
                        type: 'error'
                    });
                }
            });
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]]}!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/js/components/Users.vue
// module id = 49
// module chunks = 0